// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2eTIg","requiredAsterisk":"Info_requiredAsterisk__3bTHX"};